var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user)?_c('b-row',[_c('b-col',[_c('horizontal-nav',{attrs:{"items":_vm.items,"set_view":"","show_display":false}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }